import { Cancel, Modal, Save } from "components/UI";
import { Form, Input } from "antd";
import { useRef, useState } from "react";
import { useCreateContactGroup, useUpdateContactGroup } from "queries/contact";
import { useTranslation } from "react-i18next";
import { useAntdMessage } from "hooks/useAntdMessage";

const AddForm = ({ open, onCancel, data, refetch, callback }) => {
  const { message } = useAntdMessage();
  const { t } = useTranslation();
  const ref = useRef();
  const inputRef = useRef();
  const addContactGroup = useCreateContactGroup();
  const updateContactGroup = useUpdateContactGroup();
  const [loading, setLoading] = useState({
    create_update: false,
    delete: false,
  });

  const submitHandler = () => {
    const form = ref.current;
    form
      .validateFields()
      .then((values) => {
        setLoading((prev) => ({ ...prev, create_update: true }));
        const payload = {
          id: data?.id,
          name: values.name,
        };
        if (data?.id) {
          updateContactGroup.mutate(payload, {
            onSuccess: async (response) => {
              if (response.data.success) {
                await refetch();
                setLoading((prev) => ({ ...prev, create_update: false }));
                onCancel();
                message.success(t("update_contact_group_success"));
              }
            },
            onError: () => {
              setLoading((prev) => ({ ...prev, create_update: false }));
              message.error(t("update_contact_group_failed"));
            },
          });
        } else {
          addContactGroup.mutate(payload, {
            onSuccess: async (response) => {
              if (response.data.success) {
                await refetch();
                setLoading((prev) => ({ ...prev, create_update: false }));
                onCancel();
                message.success(t("create_contact_group_success"));
                if (typeof callback === "function") {
                  callback(response);
                }
              }
            },
            onError: () => {
              setLoading((prev) => ({ ...prev, create_update: false }));
              message.error(t("create_contact_group_failed"));
            },
          });
        }
      })
      .catch((info) => {
        console.log(info);
      });
  };

  return (
    <Modal
      title={data?.id ? t("edit_group") : t("add_group")}
      open={open}
      onCancel={onCancel}
      destroyOnHidden
      afterOpenChange={(open) => open && inputRef.current?.focus()}
      style={{ top: 50 }}
      footer={[
        <Cancel key={`_${0}`} onClick={onCancel} />,
        <Save
          loading={loading.create_update}
          form="contactGroupForm"
          key="submit"
          htmlType="submit"
          className="inline-flex"
        />,
      ]}
    >
      <Form
        id="contactGroupForm"
        layout="vertical"
        ref={ref}
        initialValues={{
          name: data?.name,
        }}
        onFinish={submitHandler}
      >
        <Form.Item
          label={t("name")}
          name="name"
          rules={[
            {
              required: true,
              message: t("please_input_the_unit_name"),
            },
            {
              max: 20,
              message: t("error.max_characters", { value: 20 }),
            },
            {
              min: 2,
              message: t("error.min_characters", { value: 2 }),
            },
            {
              pattern: /^[\w\s]+$/,
              message: t("only_alphanumeric_allowed"),
            },
          ]}
        >
          <Input ref={inputRef} placeholder={t("name")} autoFocus={true} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddForm;
